import { createFileRoute } from '@tanstack/react-router'
import { ScRegistersPage } from '@/features/support-coordination/registers'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/registers',
)({
  component: ScRegistersPage,
})
